import axios from 'axios';
import * as jose from 'jose';
import { t } from 'i18next';
import { getFingerprint } from './fingerprintUtils';
import { beginStartupCheck, finishStartupCheck } from './startupValidation';

const { version } = require('../../package.json');

const SKIP_LICENSE_ERROR_YES = 'yes';
const SKIP_VERIFY_LICENSE_YES = 'yes';

const getVerifyLicensePostData = (licenseToken, fingerprintId, orderNumber, user, client) => {
  return {
    LICENSE_TOKEN: licenseToken,
    fingerprint: fingerprintId,
    version: version.replace('-', '.'),
    domain: window.location.hostname,
    orderNumber,
    user,
    client,
  };
};

export const verifyLicense = async (verifyLicenseUrl, licenseToken, orderNumber, user, client) => {
  // For very special clients
  if (process.env.SKIP_VERIFY_LICENSE === SKIP_VERIFY_LICENSE_YES) {
    return { isValidLicense: true };
  }

  const fingerprintId = await getFingerprint();

  beginStartupCheck('licenseVerification', 'License verification');

  let isValidLicense;
  let licenseExpirationDate;
  let verifyLicenseErrorMessage = t('license.verificationError');
  try {
    const postData = getVerifyLicensePostData(licenseToken, fingerprintId, orderNumber, user, client);
    const response = await axios.post(verifyLicenseUrl, postData);

    if (response.status === 200) {
      if (response.data.code === 200) {
        licenseExpirationDate = new Date(response.data.expirationDate);
        isValidLicense = true;
      } else if (response.data.code === 404.2) {
        verifyLicenseErrorMessage = t('license.isExpired');
      } else if (response.data.code === 404.1) {
        verifyLicenseErrorMessage = t('license.notFound');
      } else {
        console.error(`*** error unhandled internal code: ${response.status}`);
        return undefined;
      }
    } else {
      console.error(`*** error unhandled Http code: ${response.status}`);
      return undefined;
    }
  } catch (error) {
    console.error('*** ERROR CALL LICENSE VERIFICATION. Error message: ', error, `\n\nurl: ${verifyLicenseUrl}`, '\ntoken:', licenseToken);
    if (error.response && error.response.status >= 400 && error.response.status < 500 && error.response.data && error.response.data.message) {
      console.error('Error message reason from server: ', error.response.data.message);
    }
  }

  // for special clients
  if ((typeof process.env.SKIP_LICENSE_ERROR !== undefined) && (process.env.SKIP_LICENSE_ERROR === SKIP_LICENSE_ERROR_YES)) {
    isValidLicense = true;
  } //

  return { isValidLicense, licenseExpirationDate, verifyLicenseErrorMessage };
};

export const getLicenseID = (licenseToken) => {
  const payload = jose.decodeJwt(licenseToken);
  const licenseID = payload.license || '';
  queueMicrotask(console.log.bind(console, `License ID: ${licenseID}`));

  return licenseID;
};

export const getLicenseConfig = async (licenseConfigUrl, licenseToken) => {
  let licenseConfig;
  let succeeded = false;
  try {
    const postData = { LICENSE_TOKEN: licenseToken };
    const response = await axios.post(licenseConfigUrl, postData);
    if (response.status === 200) {
      licenseConfig = response.data;
      succeeded = Boolean(licenseConfig && typeof licenseConfig === 'object' && !Array.isArray(licenseConfig));
    } else {
      console.error(`*** error unhandled Http code: ${response.status}`);
      return undefined;
    }
  } catch (error) {
    console.error('*** ERROR GET LICENSE CONFIG. Error message: ', error, `\n\nurl: ${licenseConfigUrl}`, '\ntoken:', licenseToken);

    if (error.response && error.response.status >= 400 && error.response.status < 500) {
      if (error.response.data && error.response.data.message) {
        console.error('Error message reason from server: ', error.response.data.message);
      }
    }
  } finally {
    finishStartupCheck('securityConfig', succeeded);
  }

  return succeeded ? licenseConfig : undefined;
};
